import update from 'immutability-helper';
import * as types from './types';

type Zoom = [number, number];
type Brush = [number, number];

export interface IState {
  defaultZoom: Zoom;
  defaultBrush: Brush;
  zoom: Zoom;
  brush: Brush;
}

const initialState: IState = {
  defaultZoom: [0, 100],
  defaultBrush: [0, 0],
  zoom: [0, 100],
  brush: [0, 0],
};

const switchMap: {
  [key in keyof typeof types]?: (
    state: IState,
    action: Partial<{ type: keyof typeof types }>,
  ) => IState;
} = {};

switchMap[types.INIT_CHART] = (state) =>
  update(state, {
    $set: initialState,
  });

switchMap[types.RESET_CHART] = (state) =>
  update(state, {
    $set: initialState,
  });

switchMap[types.SET_DEFAULT_SLICE] = (state, action) =>
  update(state, {
    $merge: {
      defaultZoom: action.defaultZoom,
      defaultBrush: action.defaultBrush,
    },
  });

switchMap[types.SET_SLICE] = (state, action) => {
  return update(state, {
    $merge: {
      zoom: action.zoom,
      brush: action.brush,
    },
  });
};

switchMap[types.INJECT_SHARED_STATE] = (state, action) =>
  update(state, {
    $merge: action.state,
  });

export default (state = initialState, action) =>
  switchMap[action.type] ? switchMap[action.type](state, action) : state;
